import { tz } from "@date-fns/tz"
import { format } from "date-fns"
import { Timestamp as TimestampPB } from "gen/google/protobuf/timestamp_pb"

export class Timestamp {
  static format(f: Format, t?: TimestampPB | null, timeZone?: string): string {
    if (!t) {
      return ""
    }

    return Timestamp.formatDate(f, TimestampPB.toDate(t), timeZone)
  }

  static formatDate(f: Format, d?: Date | null, timeZone?: string): string {
    if (!d) {
      return ""
    }

    return format(d, f, timeZone ? { in: tz(timeZone) } : undefined)
  }

  // eqFromDate is a helper function to check if two possibly undefined Dates are equal
  static eqFromDate(dateA?: Date | null, dateB?: Date | null): boolean {
    if (!dateA && !dateB) {
      return true
    }

    if (!!dateA && !!dateB) {
      return TimestampPB.equals(
        TimestampPB.fromDate(dateA),
        TimestampPB.fromDate(dateB)
      )
    }

    return false
  }
}

export enum Format {
  DATE = "MMM d, yyyy",
  DATE_SHORT = "M/d/yy",
  DATE_MONTH_DAY = "MMM d",
  TIME = "h:mm aaa",
  DATE_TIME = "MMM d, yyyy 'at' h:mm aaa",
  DATE_TIME_SHORT = "MMM d, yyyy h:mmaaa",
  DAY_DATE_TIME = "E M/d/yy h:mm aaa",
  DATE_MONTH_YEAR = "MMMM yyyy",
  DATE_MONTH_YEAR_SHORT = "MMM yyyy",
  DATE_MONTH_YEAR_TIME = "M/d/yy 'at' h:mmaaa",
  DATE_YEAR_MONTH_DAY = "yyyy_MM_dd",
}
